// this file is automatically generated by /configure.ts script
export const config = {
	clientId: '5lqguno3c60h30b12d4d1b6i5b',
	version: '',
	entraClientId: '18f29ce1-d8c1-4ffd-ac7f-8b7aaf520b04',
	bugsnagKey: 'undefined'
}